"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _NotifyIcon = _interopRequireDefault(require("../NotifyIcon"));
var _Checkbox = _interopRequireDefault(require("./Checkbox"));
var _elements = require("./elements");
var _excluded = ["label", "isCheckbox", "labelId", "id", "multiple", "chipSize", "chipColor", "optionsObj", "clear", "setClear", "handleFilter", "setInitStates", "allOption"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ITEM_HEIGHT = 48;
var ITEM_PADDING_TOP = 8;
var MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left'
  }
};
var SelectFilter = function SelectFilter(_ref) {
  var label = _ref.label,
    isCheckbox = _ref.isCheckbox,
    labelId = _ref.labelId,
    id = _ref.id,
    multiple = _ref.multiple,
    chipSize = _ref.chipSize,
    chipColor = _ref.chipColor,
    optionsObj = _ref.optionsObj,
    clear = _ref.clear,
    setClear = _ref.setClear,
    handleFilter = _ref.handleFilter,
    setInitStates = _ref.setInitStates,
    allOption = _ref.allOption,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedValue = _useState2[0],
    setSelectedValue = _useState2[1];
  var clearFilter = (0, _react.useCallback)(function () {
    setSelectedValue([]);
    setInitStates();
    setClear(false);
  }, [setClear, setInitStates, setSelectedValue]);
  (0, _react.useEffect)(function () {
    if (clear) {
      clearFilter();
    }
  }, [clear, clearFilter]);
  (0, _react.useEffect)(function () {
    if (selectedValue.length >= 0) {
      handleFilter(selectedValue);
    }
  }, [selectedValue]);
  var handleChange = function handleChange(event) {
    setSelectedValue(event.target.value);
  };
  var returnLabel = function returnLabel(value) {
    var searchLabel = optionsObj.filter(function (item) {
      return value === item.value;
    });
    return searchLabel[0].label;
  };
  var handleDelete = function handleDelete(value) {
    var newState = selectedValue.filter(function (item) {
      return item !== value;
    });
    setSelectedValue(newState);
  };
  return /*#__PURE__*/_react["default"].createElement(_elements.FormControlWrapper, null, /*#__PURE__*/_react["default"].createElement(_material.InputLabel, null, label), isCheckbox ? /*#__PURE__*/_react["default"].createElement(_material.Select, _extends({
    labelId: labelId,
    id: id,
    multiple: multiple,
    value: selectedValue,
    onChange: handleChange,
    IconComponent: function IconComponent() {
      return /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
        iconName: "filter",
        fontSize: "default",
        color: "primary"
      });
    },
    input: /*#__PURE__*/_react["default"].createElement(_material.Input, {
      id: "select-multiple-chip"
    }),
    renderValue: function renderValue(selected) {
      return /*#__PURE__*/_react["default"].createElement(_elements.ChipsStyled, null, selected.map(function (value) {
        return /*#__PURE__*/_react["default"].createElement(_elements.ChipStyled, {
          key: value,
          label: returnLabel(value),
          clickable: true,
          deleteIcon: /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
            fontSize: "default",
            iconName: "cancel",
            onMouseDown: function onMouseDown(event) {
              return event.stopPropagation();
            }
          }),
          size: chipSize,
          color: chipColor,
          onDelete: function onDelete() {
            return handleDelete(value);
          }
        });
      }));
    },
    MenuProps: MenuProps
  }, props), optionsObj.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: item.value,
      value: item.value
    }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
      checked: selectedValue.indexOf(item.value) > -1,
      color: "primary"
    }), item.label);
  })) : /*#__PURE__*/_react["default"].createElement(_material.Select, _extends({
    labelId: labelId,
    id: id,
    value: selectedValue,
    onChange: handleChange,
    IconComponent: function IconComponent() {
      return /*#__PURE__*/_react["default"].createElement(_NotifyIcon["default"], {
        iconName: "filter",
        fontSize: "default",
        color: "primary"
      });
    },
    input: /*#__PURE__*/_react["default"].createElement(_material.Input, {
      id: "select-simple"
    }),
    MenuProps: MenuProps
  }, props), allOption ? /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
    value: "",
    style: {
      backgroundColor: 'transparent'
    }
  }, label) : '', optionsObj.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_material.MenuItem, {
      key: item.value,
      value: item.value
    }, item.label);
  })));
};
SelectFilter.propTypes = {
  label: _propTypes["default"].string.isRequired,
  isCheckbox: _propTypes["default"].bool,
  labelId: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string,
  multiple: _propTypes["default"].bool,
  chipSize: _propTypes["default"].string,
  chipColor: _propTypes["default"].string,
  optionsObj: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Object)).isRequired,
  clear: _propTypes["default"].bool,
  setClear: _propTypes["default"].func,
  handleFilter: _propTypes["default"].func,
  setInitStates: _propTypes["default"].func,
  allOption: _propTypes["default"].bool
};
SelectFilter.defaultProps = {
  isCheckbox: false,
  id: '',
  multiple: false,
  chipSize: 'small',
  chipColor: 'primary',
  clear: false,
  setClear: function setClear() {},
  handleFilter: function handleFilter() {},
  setInitStates: function setInitStates() {},
  allOption: false
};
var _default = exports["default"] = SelectFilter;